export default {
      id: "alert-circle-usage",
      viewBox: "0 0 24 24",
      url: "/dist/svg/" + "sprite.svg#alert-circle-usage",
      toString: function () {
        return this.url;
      }
    }